// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","container":"input_container__5wIFR","title":"input_title__swHjz","input":"input_input__AodH7","filled":"input_filled__Qu9-T","error":"input_error__orTUK"};